import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59445148"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "feedback-container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "restaurant-info" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"bold","font-size":"20px"} }, "贵州师范大学食堂")
], -1))
const _hoisted_4 = { class: "feedback-options" }
const _hoisted_5 = { style: {"padding":"0 15px","display":"flex","align-items":"center","justify-content":"space-between","margin":"20px"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0","font-size":"20px","font-weight":"bold"} }, "反馈改善公示", -1))
const _hoisted_7 = { style: {"display":"flex","gap":"5px"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("建议采纳")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("就餐好评")
const _hoisted_10 = {
  class: "card",
  style: {"height":"200px"}
}
const _hoisted_11 = { class: "improvement-list" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "content" }
const _hoisted_14 = { class: "left" }
const _hoisted_15 = { class: "right" }
const _hoisted_16 = { class: "contact-dialog" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "联系电话：123-4567-8910", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 拨打电话 ")

import { ref } from 'vue';
import { Toast, Dialog } from 'vant';
import { req } from '@/axios/http';
import { useRouter } from "vue-router";
interface ImprovementItem {
  "id": "",
  "category": "",
  "type": "",
  "schoolId": "",
  "target": "",
  "title": "",
  "description": "",
  "pictures": [],
  "isAnonymous": true,
  "memberId": "",
  "memberName": "",
  "phone": "",
  "email": "",
  "isReplied": true,
  "replyTitle": "",
  "replyContent": "",
  "replyPictures": [],
  "extJson": "",
  "createTime": "",
  "updateTime": "",
}

export default /*#__PURE__*/_defineComponent({
  __name: 'schoolProblemFeedback',
  setup(__props) {

const router = useRouter();
// 定义网格项数据
const gridItems = ref([
  // { icon: 'question-o', text: '问题反馈', route: '/schoolProblemFeedback/form?type=problem' },
  { icon: 'edit', text: '我要建议', route: '/schoolProblemFeedback/form?type=suggestion' },
  { icon: 'good-job-o', text: '我要好评', route: '/schoolProblemFeedback/form?type=praise' }
]);

const handleClick = (index, route) => {
  if (!route) {
    Toast('路由配置错误，请联系管理员');
    return;
  }
  router.push(route);
};
const activeTab = ref<string>('我要建议')
// 回复列表状态管理
const list = ref<ImprovementItem[]>([]);
const loading = ref(false);
const noMoreData = ref(false);
const page = ref(1);
const pageSize = 10;
// 获取数据
const fetchData = async (update = true) => {
  if (update && (loading.value || noMoreData.value)) return;
  loading.value = true;
  req.get({
    url: "/app/rabbit/user/common-feedback/page-is-replay",
    params: {
      type: activeTab.value,
      page: update ? page.value : 1,
      size: 10
    },
  }).then((res) => {
    const newData = res.data.records
    if (newData.length < pageSize) {
      noMoreData.value = true;
    }
    if (update) {
      list.value = [...list.value, ...newData];
      page.value++;
    } else {
      list.value = [...newData]
      page.value = 1
    }

    loading.value = false;
  })
};
const activeTabChange = async (value: string) => {
  activeTab.value = value
  fetchData(false)
}
fetchData()

const showContactDialog = ref(false);

const handleBack = () => {
  // 实际项目中可能是路由返回
  window.history.back();
};

const handleMakePhoneCall = () => {
  showContactDialog.value = false;
  Dialog.alert({
    title: '提示',
    message: '即将拨打 123-4567-8910',
  }).then(() => {
    console.log('拨打电话');
  });
};

return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_grid_item = _resolveComponent("van-grid-item")!
  const _component_van_grid = _resolveComponent("van-grid")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_image, {
      fit: "cover",
      src: "http://yunlei-rabbit-hn2.oss-cn-heyuan.aliyuncs.com/2025/4/28/1916700564430307329.png"
    }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_van_grid, {
        gutter: 30,
        "column-num": 2
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gridItems.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_grid_item, {
              key: index,
              icon: item.icon,
              text: item.text,
              onClick: ($event: any) => (handleClick(index, item.route))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_van_icon, {
                  name: item.icon,
                  style: {"color":"#16d5c3"},
                  size: "100%"
                }, null, 8, ["name"])
              ]),
              _: 2
            }, 1032, ["icon", "text", "onClick"]))
          }), 128))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_cell, {
          title: "联系食堂负责人",
          "is-link": "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showContactDialog.value = true)),
          icon: "phone-o"
        })
      ])
    ]),
    _createVNode(_component_van_divider),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_van_button, {
          class: "custom-round custom-primary",
          size: "small",
          type: activeTab.value === '我要建议' ? 'primary' : 'default',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTabChange('我要建议')))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_van_button, {
          class: "custom-round custom-primary",
          size: "small",
          type: activeTab.value === '我要好评' ? 'primary' : 'default',
          onClick: _cache[2] || (_cache[2] = ($event: any) => (activeTabChange('我要好评')))
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["type"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[3] || (_cache[3] = ($event: any) => ((loading).value = $event)),
          finished: noMoreData.value,
          "finished-text": "没有更多数据了",
          onLoad: fetchData
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"font-size":"medium"},
                key: index,
                class: "list-item",
                onClick: ($event: any) => (_ctx.goToDetail(item))
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, "【" + _toDisplayString(item.type) + "】" + _toDisplayString(item.replyTitle), 1),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(item.createTime), 1)
                ])
              ], 8, _hoisted_12))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ])
    ]),
    _createVNode(_component_van_dialog, {
      show: showContactDialog.value,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((showContactDialog).value = $event)),
      title: "联系食堂负责人",
      "show-cancel-button": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_component_van_button, {
            type: "primary",
            block: "",
            onClick: handleMakePhoneCall
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})